import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=2d2cf4fb&scoped=true&"
import script from "./Step6.vue?vue&type=script&lang=js&"
export * from "./Step6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2cf4fb",
  null
  
)

export default component.exports